import { OpportunityRequirement } from './requirement';

export namespace OpportunitySchema {
  export interface BaseDefinition {
    requirement: OpportunityRequirement.ValueRequirement | null;
  }

  export type StringPropertyDefinition = BaseDefinition;
  export type StringArrayPropertyDefinition = BaseDefinition;
  export type BooleanPropertyDefinition = BaseDefinition;
  export type EmptyObjectPropertyDefinition = BaseDefinition;

  interface SchemaNumberRange {
    min: number | null;
    max: number | null;
  }

  export type NumberPropertyDefinition = {
    range: SchemaNumberRange;
  } & BaseDefinition;

  export type OptionsPropertyDefinition = {
    options: string[];
  } & BaseDefinition;

  export const EmptyDefinition: BaseDefinition = {
    requirement: null
  };

  export function isPropertyDefinition(
    definition: any
  ): definition is BaseDefinition {
    return definition && 'requirement' in definition;
  }

  export function isNumberPropertyDefinition(
    definition: any
  ): definition is NumberPropertyDefinition {
    return isPropertyDefinition(definition) && 'range' in definition;
  }
}
